"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var material_1 = require("@mui/material");
// locals
var types_1 = require("../../util/types");
var LocalFileChooser_1 = __importDefault(require("./LocalFileChooser"));
var UrlChooser_1 = __importDefault(require("./UrlChooser"));
// icons
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
function ToggleButtonWithTooltip(props) {
  var title = props.title,
    children = props.children,
    other = _objectWithoutProperties(props, ["title", "children"]);
  return react_1.default.createElement(material_1.Tooltip, {
    title: title || ''
  }, react_1.default.createElement(material_1.ToggleButton, _objectSpread({}, other), children));
}
function shorten(str, len) {
  if (typeof str === 'string' && str.length > len) {
    return "".concat(str.substring(0, len), "\u2026");
  }
  return str;
}
var FileSelector = (0, mobx_react_1.observer)(function (props) {
  var location = props.location,
    name = props.name,
    description = props.description,
    rootModel = props.rootModel,
    setLocation = props.setLocation;
  var fileOrUrl = !location || (0, types_1.isUriLocation)(location) ? 'url' : 'file';
  var _ref = (0, react_1.useState)(location && 'internetAccountId' in location && location.internetAccountId ? location.internetAccountId : fileOrUrl),
    _ref2 = _slicedToArray(_ref, 2),
    toggleButtonValue = _ref2[0],
    setToggleButtonValue = _ref2[1];
  var accts = (0, types_1.isAppRootModel)(rootModel) ? rootModel.internetAccounts.slice() : [];
  var numShown = 2;
  var _ref3 = (0, react_1.useState)(accts.slice(0, numShown)),
    _ref4 = _slicedToArray(_ref3, 2),
    shownAccts = _ref4[0],
    setShownAccts = _ref4[1];
  var _ref5 = (0, react_1.useState)(accts.slice(numShown)),
    _ref6 = _slicedToArray(_ref5, 2),
    hiddenAccts = _ref6[0],
    setHiddenAccts = _ref6[1];
  var _ref7 = (0, react_1.useState)(null),
    _ref8 = _slicedToArray(_ref7, 2),
    anchorEl = _ref8[0],
    setAnchorEl = _ref8[1];
  var selectedAcct = accts.find(function (ia) {
    return ia.internetAccountId === toggleButtonValue;
  });
  var setLocationWithAccount = function setLocationWithAccount(location) {
    setLocation(_objectSpread({}, location, {
      internetAccountId: selectedAcct ? selectedAcct.internetAccountId : undefined
    }));
  };
  // if you swap account selection after inputting url
  if (location && selectedAcct && (0, types_1.isUriLocation)(location) && location.internetAccountId !== selectedAcct.internetAccountId) {
    setLocationWithAccount(location);
  }
  var locationInput = react_1.default.createElement(UrlChooser_1.default, _objectSpread({}, props, {
    setLocation: setLocationWithAccount,
    label: selectedAcct === null || selectedAcct === void 0 ? void 0 : selectedAcct.selectorLabel
  }));
  if (toggleButtonValue === 'file') {
    locationInput = react_1.default.createElement(LocalFileChooser_1.default, _objectSpread({}, props));
  }
  if (selectedAcct === null || selectedAcct === void 0 ? void 0 : selectedAcct.SelectorComponent) {
    var SelectorComponent = selectedAcct.SelectorComponent;
    locationInput = react_1.default.createElement(SelectorComponent, _objectSpread({}, props, {
      setLocation: setLocationWithAccount
    }));
  }
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Box, {
    display: "flex"
  }, react_1.default.createElement(material_1.InputLabel, {
    shrink: true
  }, name)), react_1.default.createElement(material_1.Box, {
    display: "flex",
    flexDirection: "row"
  }, react_1.default.createElement(material_1.Box, null, react_1.default.createElement(material_1.ToggleButtonGroup, {
    value: toggleButtonValue,
    exclusive: true,
    onChange: function onChange(_event, newState) {
      if (newState) {
        setToggleButtonValue(newState);
      }
      if ((0, types_1.isUriLocation)(location)) {
        setLocationWithAccount(location);
      }
    },
    "aria-label": "file, url, or account picker"
  }, new URLSearchParams(window.location.search).get('adminKey') ? null : react_1.default.createElement(material_1.ToggleButton, {
    value: "file",
    "aria-label": "local file"
  }, "File"), react_1.default.createElement(material_1.ToggleButton, {
    value: "url",
    "aria-label": "url"
  }, "URL"), shownAccts.map(function (_ref9) {
    var internetAccountId = _ref9.internetAccountId,
      toggleContents = _ref9.toggleContents,
      name = _ref9.name;
    return react_1.default.createElement(ToggleButtonWithTooltip, {
      key: internetAccountId,
      value: internetAccountId,
      "aria-label": name,
      title: name
    }, typeof toggleContents === 'string' ? shorten(toggleContents, 5) : toggleContents || shorten(name, 5));
  }), hiddenAccts.length ?
  // @ts-ignore
  react_1.default.createElement(material_1.ToggleButton, {
    onClick: function onClick(event) {
      return setAnchorEl(event.target);
    },
    selected: false
  }, "More", react_1.default.createElement(ArrowDropDown_1.default, null)) : null), react_1.default.createElement(material_1.Menu, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, hiddenAccts === null || hiddenAccts === void 0 ? void 0 : hiddenAccts.map(function (acct, idx) {
    return react_1.default.createElement(material_1.MenuItem, {
      key: acct.internetAccountId,
      value: acct.internetAccountId,
      onClick: function onClick() {
        var prev = shownAccts[shownAccts.length - 1];
        setShownAccts([].concat(_toConsumableArray(shownAccts.slice(0, shownAccts.length - 1)), [acct]));
        setHiddenAccts([prev].concat(_toConsumableArray(hiddenAccts.slice(0, idx)), _toConsumableArray(hiddenAccts.slice(idx + 1))));
        setToggleButtonValue(acct.internetAccountId);
        setAnchorEl(null);
      }
    }, acct.name);
  })))), locationInput, react_1.default.createElement(material_1.FormHelperText, null, description));
});
exports.default = FileSelector;